import React, { useState } from "react";

import { Flex } from "../../../../../../../../../../mads";
import type Sentiment from "../../../../../../../../../../shared/util/salary/Sentiment";
import { YesNoButtons } from "../../YesNoButtons";

export type SentimentFormProps = {
  onChange: (data: { sentiment?: Sentiment }) => void;
  isLoading: boolean;
  handleSave: (sentiment: Sentiment) => Promise<boolean>;
  onClose: () => void;
  value: { sentiment: Sentiment };
  accessibilityQuestionText?: string;
};

export const SentimentForm: React.FunctionComponent<SentimentFormProps> = ({
  onChange,
  value,
  isLoading,
  handleSave,
  onClose,
  accessibilityQuestionText,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  return (
    <>
      <Flex
        sx={{
          flexDirection: "column",
          marginTop: 2,
          justifyContent: "space-between",
          gap: 4,
        }}
      >
        <YesNoButtons
          value={value?.sentiment}
          isAnimating={isAnimating}
          disabled={isLoading}
          accessibilityQuestionText={accessibilityQuestionText}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises -- FIXME
          onSubmit={async (s: Sentiment) => {
            onChange({ sentiment: s });
            const success = await handleSave(s).catch(() => {});
            if (success) {
              setIsAnimating(true);
              setTimeout(() => {
                setIsAnimating(false);
                onClose();
              }, 1000);
            }
          }}
        />
      </Flex>
    </>
  );
};
